import withAttr from 'flarum/common/utils/withAttr';
import Field from './Field';

export default class Date extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'min',
            'max',
        ]);
    }

    configure() {
        return this.minMaxRules('date');
    }

    fill() {
        const attrs: any = {
            type: 'date',
            id: this.uniqueFieldId(),
            className: this.validationErrorsForThisField() ? 'in-error' : '',
            value: this.getSubmission(),
            onchange: withAttr('value', this.setSubmission.bind(this)),
            disabled: this.isFillDisabled(),
        };

        if (this.getConfig('min')) {
            attrs.min = this.getConfig('min');
        }

        if (this.getConfig('max')) {
            attrs.max = this.getConfig('max');
        }

        return m('input.FormControl', attrs);
    }
}
